module.exports = __webpack_public_path__ + "static/media/file.2a61993d.svg";